import React from "react";

interface SettingElementFieldProps {
  title: string;
  handleClick: () => void;
  className?: string;
}

export const SettingElementField = ({
  title,
  handleClick,
  className,
}: SettingElementFieldProps) => {
  return (
    <li>
      <button type="button" onClick={handleClick} className={className}>{title}</button>
    </li>
  );
};
